"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumEx = exports.UserGroupLabels = exports.EUserGroup = void 0;
var EUserGroup;
(function (EUserGroup) {
    EUserGroup[EUserGroup["PRTCM"] = 0] = "PRTCM";
    EUserGroup[EUserGroup["PRTCM_DELEGATE"] = 10] = "PRTCM_DELEGATE";
    EUserGroup[EUserGroup["PRTCM_READONLY"] = 15] = "PRTCM_READONLY";
    EUserGroup[EUserGroup["COLLAUDATORE"] = 20] = "COLLAUDATORE";
    EUserGroup[EUserGroup["METODISTA"] = 30] = "METODISTA";
    EUserGroup[EUserGroup["PQM"] = 40] = "PQM";
    EUserGroup[EUserGroup["PQM_DELEGATE"] = 50] = "PQM_DELEGATE";
    EUserGroup[EUserGroup["EHS"] = 110] = "EHS";
    // Below ptw related roles
    EUserGroup[EUserGroup["QUALITY"] = 60] = "QUALITY";
    EUserGroup[EUserGroup["PTW_ISSUER"] = 100] = "PTW_ISSUER";
})(EUserGroup = exports.EUserGroup || (exports.EUserGroup = {}));
exports.UserGroupLabels = {
    PRTCM: 'PRTCM',
    PRTCM_DELEGATE: 'Delegato PRTCM',
    PRTCM_READONLY: 'PRTCM (Sola lettura)',
    COLLAUDATORE: 'Collaudatore',
    METODISTA: 'Metodista',
    PQM: 'PQM',
    PQM_DELEGATE: 'Delegato PQM',
    QUALITY: 'Ispettore Qualità',
    PTW_ISSUER: 'Richiedente PTW',
    EHS: 'EHS',
};
class EnumEx {
    static getNamesAndValues(e) {
        return EnumEx.getNames(e).map((n) => ({ name: n, value: e[n] }));
    }
    static getNames(e) {
        return Object.keys(e).filter((k) => typeof e[k] === 'number');
    }
    static getValues(e) {
        return Object.keys(e)
            .map((k) => e[k])
            .filter((v) => typeof v === 'number');
    }
}
exports.EnumEx = EnumEx;
